import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { bankCardMobx, surchargeMobx } from '@mobxStore'
import { SelectBankCardModal } from '@pages/checkout/modal'

interface IProps {
  channel?: TPayChannelType;
  payRechargeFlag?: boolean;
  bankCards?: IMutBankCardInfo[];
  selected: boolean;
  amount: number;
  card: TBankCardInfo;
  onChange: (data?: any) => void;
}

const BankCardSimpleItem: FC<IProps> = ({ channel, payRechargeFlag, bankCards, selected, amount, onChange, card }) => {
  bankCards = bankCards || bankCardMobx?.memberBankCards

  // 附加费
  const surchargeInfo = card && card.tokenType === 'multi' && card.creditCardNumber ? (card?.creditCardType && card?.creditCardType !== 'N' ? surchargeMobx.surchargeMap?.[channel] : null) : surchargeMobx.surchargeMap?.[channel]
  const surcharge = surchargeInfo ? amount * (surchargeInfo.rate / 100) : 0

  const handleChange = () => {
    if (selected && card?.tokenType === 'multi' && bankCards?.length > 0) {
      modalLayer(SelectBankCardModal, { payRechargeFlag, bankCards, selectedCard: card }, 'selectBankCardModal').then((data: any) => {
        onChange(data)
      }).catch(() => {
        onChange()
      })
    } else {
      onChange()
    }
  }

  return (
    <div
      className={classNames('external-pay-method-item', 'bank-card-online', { selected })}
      data-cypid='bankCardSimpleItem'
      onClick={handleChange}
    >
      <div className='card-left'>
        <i className='iconfont icon-xinyongka'> </i>
      </div>
      <div className='card-content'>
        <div className='title-top'>
          {
            card && card.tokenType === 'multi' && card.creditCardNumber ? (
              <div className='name'>{format.maskCardNumber(card.creditCardNumber)}</div>
            ) : (
              <div className='name'>
                {i18n.t('pay.bankCard')}
              </div>
            )
          }
          {surchargeInfo && !!surcharge && (
            <div className='sub-name'>
              {i18n.t('pay.surcharge.cardTip', { name: surchargeInfo.name, rate: `${surchargeInfo.rate}%`, amount: format.toPrice(surcharge) })}
            </div>
          )}
          {bankCards?.length > 0 ? (<div className='triangle-tip'></div>) : ''}
        </div>
        <div className='amount'>
          {selected && format.toPrice(amount + surcharge)}
        </div>
      </div>
      <div className='amount-select'>
        <i className={classNames('iconfont', selected ? 'icon-checked' : 'no-select')} />
      </div>
    </div>
  )
}

export default observer(BankCardSimpleItem)
